import { Form, Formik } from "formik";
import MyText from "../../../../components/Input/MyText";
import {
    DeclarationsService,
    Delaration,
} from "../../../../services/api/declarationsService";
import * as Yup from "yup";
import { useState } from "react";
import { Box, Button, Divider } from "@mui/material";
import dayjs from "dayjs";

type Props = {
    uuid: string;
    pid: string;
    caseType: "AddSingle" | "Edit";
    close: () => void;
    declaration?: Delaration & { id: string };
    refresh: () => void;
};

const validationSchema = Yup.object({
    declarationDate: Yup.string().required(
        "Declaration date must not be empty"
    ),
    goodsValue: Yup.number().required("Goods value must not be empty"),
    remark: Yup.string().required("Remark must not be empty"),
    receiverName: Yup.string(),
    receiverAddress: Yup.string(),
    consignmentDetails: Yup.string(),
    senderName: Yup.string(),
    invoiceNumber: Yup.string(),
    invoiceDate: Yup.string().nullable(),
    transportationMode: Yup.string(),
    transportationNumber: Yup.string(),
    active: Yup.boolean(),
});

const handleSubmit = async (
    caseType: "AddSingle" | "Edit",
    values: Delaration & { id?: string },
    pid: string,
    uuid: string,
    refresh: () => void,
    close: () => void,
    setIsLoading: (loading: boolean) => void
) => {
    try {
        values.declarationDate = dayjs(values.declarationDate).format(
            "YYYY-MM-DD"
        );
        if (values.invoiceDate) {
            values.invoiceDate = dayjs(values.invoiceDate).format("YYYY-MM-DD");
        }
        if (caseType === "AddSingle") {
            setIsLoading(true);
            await DeclarationsService.createDeclarations(pid, uuid, [values]);
            close();
            refresh();
        } else {
            setIsLoading(true);
            await DeclarationsService.updateDeclarations(pid, uuid, [
                values,
            ] as (Delaration & { id: string })[]);
            close();
            refresh();
        }
        console.log("Form submitted successfully");
    } catch (error) {
        setIsLoading(false);
        console.error("Error submitting form:", error);
    }
};

const ManageSingleDeclarations = ({
    uuid,
    pid,
    caseType,
    close,
    declaration,
    refresh,
}: Props) => {
    const [isLoading, setIsLoading] = useState(false);
    const [detailedView, setDetailedView] = useState<boolean>(
        declaration
            ? !!declaration.receiverName ||
                  !!declaration.receiverAddress ||
                  !!declaration.consignmentDetails ||
                  !!declaration.senderName ||
                  !!declaration.invoiceNumber ||
                  !!declaration.invoiceDate ||
                  !!declaration.transportationMode ||
                  !!declaration.transportationNumber
            : false
    );

    const initialValues: Delaration = declaration || {
        declarationDate: "",
        goodsValue: 0,
        remark: "",
        receiverName: "",
        receiverAddress: "",
        consignmentDetails: "",
        senderName: "",
        invoiceNumber: "",
        invoiceDate: "",
        transportationMode: "",
        transportationNumber: "",
        active: true,
    };

    return (
        <Formik
            initialValues={initialValues}
            validationSchema={validationSchema}
            onSubmit={(values) => {
                let tempValues : Delaration = {...values};
                if (caseType === "AddSingle" && !detailedView) {
                    tempValues = {
                        ...values,
                        receiverName: "",
                        receiverAddress: "",
                        consignmentDetails: "",
                        senderName: "",
                        invoiceNumber: "",
                        invoiceDate: "",
                        transportationMode: "",
                        transportationNumber: "",
                    };
                } else {
                    tempValues = {
                        ...values,
                    }
                }

                handleSubmit(
                    caseType,
                    tempValues,
                    pid,
                    uuid,
                    refresh,
                    close,
                    setIsLoading
                );
            }}
        >
            <Form>
                <div className="elementContainer">
                    <MyText
                        label="Declaration date"
                        name="declarationDate"
                        type="date"
                        onChange={() => {}}
                    />
                    <MyText
                        label="Goods value"
                        name="goodsValue"
                        type="number"
                        onChange={() => {}}
                    />
                    <MyText
                        label="Remark"
                        name="remark"
                        type="text"
                        onChange={() => {}}
                    />
                    <Box
                        sx={{
                            display: "flex",
                            justifyContent: "space-between",
                            alignItems: "center",
                            marginTop: "10px",
                        }}
                        className="fullWidth"
                    >
                        <Button
                            variant="outlined"
                            size="small"
                            onClick={() => setDetailedView(!detailedView)}
                        >{
                            caseType === "Edit"
                                ? detailedView
                                    ? "Show less Details"
                                    : "Show more Details"
                                : detailedView
                                    ? "Add less details"
                                    : "Add more details"
                        }
                            {/* {detailedView ? "Hide Details" : "Show Details"} */}
                        </Button>
                    </Box>

                    {detailedView && (
                        <>
                            <MyText
                                label="Receiver name"
                                name="receiverName"
                                type="text"
                                onChange={() => {}}
                            />
                            <MyText
                                label="Receiver address"
                                name="receiverAddress"
                                type="text"
                                onChange={() => {}}
                            />
                            <MyText
                                label="Consignment details"
                                name="consignmentDetails"
                                type="text"
                                onChange={() => {}}
                            />
                            <MyText
                                label="Sender name"
                                name="senderName"
                                type="text"
                                onChange={() => {}}
                            />
                            <MyText
                                label="Invoice number"
                                name="invoiceNumber"
                                type="text"
                                onChange={() => {}}
                            />
                            <MyText
                                label="Invoice date"
                                name="invoiceDate"
                                type="date"
                                onChange={() => {}}
                            />
                            <MyText
                                label="Transportation mode"
                                name="transportationMode"
                                type="text"
                                onChange={() => {}}
                            />
                            <MyText
                                label="Transportation number"
                                name="transportationNumber"
                                type="text"
                                onChange={() => {}}
                            />
                        </>
                    )}
                </div>
                <div className="buttons">
                    <button
                        className="btn simple"
                        type="button"
                        onClick={close}
                    >
                        Cancel
                    </button>
                    <button
                        className="btn simple primary"
                        type="submit"
                        disabled={isLoading}
                    >
                        {caseType === "Edit" ? "Update" : "Add"}
                    </button>
                </div>
            </Form>
        </Formik>
    );
};

export default ManageSingleDeclarations;
